import { render, staticRenderFns } from "./CasualUpload.vue?vue&type=template&id=aa2b52a2&scoped=true&"
import script from "./CasualUpload.vue?vue&type=script&lang=js&"
export * from "./CasualUpload.vue?vue&type=script&lang=js&"
import style0 from "./CasualUpload.vue?vue&type=style&index=0&id=aa2b52a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2b52a2",
  null
  
)

export default component.exports